import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicProductCharacteristicResponse } from './public-product-characteristic.response';
import { PublicProductAttributeResponse } from './public-product-attribute.response';
import { PublicProductBrandResponse } from './public-product-brand.response';
import { PublicSalesResponse } from '@web/shared/module/shop';

@jsonObject
export class PublicProductDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly vendorUrl?: Nillable<string>;

  @jsonMember(PublicProductBrandResponse)
  public readonly cosmeticBrand?: Nillable<PublicProductBrandResponse>;

  @jsonArrayMember(MultimediaResponse)
  public readonly files!: MultimediaResponse[];

  @jsonArrayMember(PublicProductCharacteristicResponse)
  public readonly characteristics!: PublicProductCharacteristicResponse[];

  @jsonArrayMember(PublicProductAttributeResponse)
  public readonly attributes!: PublicProductAttributeResponse[];

  @jsonMember(PublicSalesResponse)
  public readonly sales!: PublicSalesResponse;
}
